import { DataBean } from "../DataBean";

export class ImporIndirectCosts extends DataBean {



    public async imporIndirectCosts(filename:any,directory:any,dataStore:any,idEmployee:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_imporIndirectCosts_String_String_String_Number", [filename,directory,dataStore,idEmployee]);
    }

    
}